export const normalizeAddr = (addr) => {
  if (!addr || typeof addr !== 'string') return '';
  const s = addr.trim().toLowerCase();
  return s.startsWith('0x') ? s : `0x${s}`;
};

export const formatAddress = (address, chars = 4) => {
  if (!address) return 'N/A';
  if (address.length <= chars * 2 + 2) return address;
  return `${address.slice(0, 2 + chars)}…${address.slice(-chars)}`;
};

export const addressesEqual = (a, b) => {
  if (!a || !b) return false;
  return normalizeAddr(a) === normalizeAddr(b);
};
